import React, { Component } from 'react';
import '../styles/Footer.css';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

class Footer extends Component {
  render() {
    return (
      <div className="Footer">
        <footer className="footer">
          <div className="container text-center pt-5 pb-5">
            <span>Mainline Crafts, Inc. 2018</span>
          </div>
        </footer>
      </div>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.js